import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { SpeechScoreName, ScoreClasses } from "../../constants/speechScore";

const SpeechAverageScore = ({ speechScore, includeLabel = false, translate }) => {
    const hasAverageScore = !isNaN(speechScore?.averageScore);

    if (!hasAverageScore) {
        return <span>{`${translatedAverageScoreLabel}-`}</span>;
    }

    const cssClass = ScoreClasses[speechScore.averageScoreLevel];
    const averageScoreLabel = SpeechScoreName[speechScore.averageScoreLevel];

    const formattedAverageScore = parseFloat(speechScore.averageScore).toFixed(1);

    return (
        <>
            <span class={`fxs_c_speech_score ${cssClass}`}>
                {includeLabel && <span> {translate(averageScoreLabel)}</span>}
                {formattedAverageScore && ` ${formattedAverageScore}`}
            </span>
        </>
    );
};

export default connectWithTranslations()(SpeechAverageScore);
